<paedml-modal-activate-mdm>
  <paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opts.opname}
                selectedrowsfunc={opts.selectedrowsfunc} idcol="0" idtextcol="1"
                submitfunc={submitHandler} patient={patient}
                cancelbutton={true} ref="modal"
                >

    <yield to="fields">
      <div class="row justify-content-center">
        <div class="col-5 ">
          <span>MDM deaktivieren</span>
        </div>
        <div class="col-1">
          <paedml-form-input name="isMdmActive"
            type="checkbox" revlut="jaNein" handlechange={parent.handleToggle}
          />
        </div>
        <div class="col-5">
          <span>MDM aktivieren</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
        <div class="mt-2 mr-1 p-2 border border-info">
            <span><paedml-icon icon="fas-info-circle" simple="info" />
                <strong class="text-info pl-1 pt-2">Aktivierung / Deaktivierung der MDM Umgebung kann bis zu 15 Minuten dauern.</strong>
            </span>
            </div>
        <div class="p-2"></div>
        </div>
      </div>

      <virtual if={parent.data.selectedRows > 1}>
        <div class="mt-2 mr-1 p-2 border border-info">
          <span><paedml-icon icon="fas-info-circle" simple="info" />
            <strong class="text-info pl-1 pt-2">Der aktuelle Zustand kann nicht ermittelt werden, da mehrere MDM Schulen ausgewählt sind.</strong>
          </span>
        </div>
        <div class="p-2"></div>
      </virtual>

      <div class="row" if={!parent.data.isMdmActive}>
        <div class="col-md-12">
          <div class="mt-2 mr-1 p-2 border border-danger">
            <span><paedml-icon icon="fas-exclamation-triangle" simple="danger" />
              <strong class="text-danger pl-1 pt-2">Alle Benutzer, Klassen, Gruppen und Projekte dieser Schule werden aus der MDM-Umgebung entfernt. Hierdurch gehen auch sämtliche Benutzer-Geräte-Zuordnungen verloren, wenn die MDM-Verbindung deaktiviert wird.
              </strong>
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="m-2 p-2">
          <span class="pl-1 pt-2">Es werden Jobs erstellt, um MDM für die {parent.data.schoolTypeText} zu {parent.data.isMdmActive ? 'aktivieren' : 'deaktivieren'}.</span>
          <p></p>
          <paedml-form-input name="redirect" placeholder="Nach der Ausführung zur 'JobQueue'-Ansicht springen" fgclass="py-1"
            type="checkbox" revlut="jaNein"
            />
        </div>
      </div>
    </yield>
  </paedml-modal>

  <script>
    import {toTrueMap} from '../../util/mapping-util'
    import {patientSingularFormatter} from '../../util/modal-util'
    import API from '../../api'

    this.prefix = opts.prefix
    this.variant = opts.variant
    this.patient = {singular: 'MDM', plural: 'MDM'}
    this.opname = this.opts.opname
    this.data = {
      text: "MDM wird aktiviert",
      patient: opts.patient,
      isMdmActive: false,
      selectedRows: 0,
      schoolTypeText: "ausgewählten Schulen"
    }

    this.op = opts.variant

    this.handleToggle = (val) => {
      this.data.isMdmActive = val
      this.refs.modal.trigger('updateButton', this.data.isMdmActive ? 'Mdm aktivieren' : 'Mdm deaktivieren')
    }

    this.on('dataRequested', (selectedRows) => {
      this.data.selectedRows = selectedRows.length
      this.data.schoolTypeText = selectedRows.length > 1 ? "ausgewählten Schulen" : `Schule ${selectedRows[0][1]}`

      var activeState = selectedRows[0][3]

      this.setInitialState(activeState)
    })

    this.setInitialState = (activeState) => {
      var isMdmActive = false;
      if(this.data.selectedRows === 1) {
        isMdmActive = activeState === "aktiv"
      }
      this.handleToggle(isMdmActive)
    }

    this.submitHandler = formData => {
      if (formData.ids.length < 1) return Promise.resolve('Operation abgebrochen')

      return API.mdm.activate(formData.ids, this.data.isMdmActive).then(rsp => {
        const [data, status] = rsp

        if (status.error) return Promise.reject(data)

        if(status.success){
          this.parent.trigger('reloadTable')

        if (this.data.redirect)  setTimeout(() => {
          $('body').removeClass('modal-open')
          window.location.href = '/#jobverwaltung/jobs'
        }, 500)

          return 'Die Jobs wurden erfolgreich erstellt.'
        }
      })
    }

  </script>
</paedml-modal-activate-mdm>
